import React, { Component } from "react";
import _ from 'lodash';
import {Table, Pagination, InputGroup, FormControl, Button} from 'react-bootstrap'
import EditModalWindow from './EditModalWindow'
import ViewWebForm from './ViewWebForm'
function searchingFor(term){ 	
  return function(x){    
      return _.includes(x.title.toLowerCase(), term.toLowerCase()) || !term;
    }
}
export default class ListTemplate extends Component {
  constructor(props){
    super(props)
    this.state={
      activePage:1,
      term:'',
      showModal:false
    }
  }
   componentWillMount(){
    this.props.action.TokenValidation()  
    this.props.action.unmappedFormList() 
    this.props.action.formNames()
  }
  componentWillReceiveProps(nextProps){
    if(!_.isEqual(nextProps.action.showModalLogin, this.props.action.showModalLogin) && nextProps.action.showModalLogin === false){     
      nextProps.action.unmappedFormList()
      nextProps.action.formNames()
    }  
  }
  handleSelectPagination = (eventKey) => {
    this.setState({
    activePage: eventKey,
    });
  }
  handleSelectPaginationPrev = () => {
    const {activePage} = this.state;
    this.setState({
    activePage: activePage-1,
    });
  }
  handleSelectPaginationNext = () => {
    const {activePage} = this.state;
    this.setState({
    activePage: activePage+1,
    });
  }
  addNew = () =>{
    this.setState({addNew:true, showModal:true})
  }	
  addNewClose = () =>{
    this.setState({addNew:false,  showModal:false})
  }	
  editMe = (index) => {
    this.setState({edit:true, showModal:true, editindex:index})
  }
  editMeClose =() => {
    this.setState({edit:false, showModal:false, editindex:null})
  }
  openModalView =(index) => {
		this.setState({['modalIsRead'+index]: true, });
	}
	
	closeModalView=(index) =>{
		this.setState({['modalIsRead'+index]: false, });
  }
  handleChange = (e) => {
		this.setState({term:e.target.value})	
  }
  render(){
    const{webtemplates, accessPermission} = this.props;		  
    let permission  = _.includes(accessPermission,'WRITE') 
    const{activePage, term, addNew, showModal, edit, editindex} = this.state;
    const Per_Page=50;
    let totalPages =1 ;
    let startCount = 0;
    let items = [];
    const startOffset = (this.state.activePage-1) * Per_Page;
    if(!_.isEmpty(webtemplates)){    
     totalPages = Math.ceil(webtemplates.length/Per_Page)    
    for (let number = 1; number <= totalPages; number++) {
      items.push(
        <Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
          {number}
        </Pagination.Item>				
      );
    }
    }
    return(<div>
      {showModal === true  ?
        (addNew === true) ?
        <EditModalWindow action={this.props.action} closeModal={this.addNewClose} loginAction={this.props.loginAction}
        webFormNames={this.props.webFormNames}
        /> : (edit === true) ?
        <EditModalWindow edit={true} action={this.props.action}   closeModal={this.editMeClose} loginAction={this.props.loginAction}
        webFormNames={this.props.webFormNames}
        form={webtemplates[editindex]}/> : null :
      <div>
      <span className='alignRight'>        
				<InputGroup>
					<InputGroup.Prepend>
						<InputGroup.Text id="basic-addon1"><i class="fas fa-search"></i></InputGroup.Text>
					</InputGroup.Prepend>
					<FormControl
						placeholder="Search"
						aria-label="Search"
						aria-describedby="basic-addon1"
						onChange={(e) => this.handleChange(e)}
						value={term}
						/>
          </InputGroup>
      </span>
      <Button className='alignRight' onClick={this.addNew}>New Web Form</Button>
       <Table responsive>
        <thead>
          <th>WEB FORMS</th>
          {(permission === true) ? <th>EDIT</th> : null}
          <th>VIEW</th>
        </thead>
        <tbody>
        {(!_.isEmpty(webtemplates)) ? 
           _.map(webtemplates.filter(searchingFor(term)), (obj, index)=>{
              if(index >= startOffset & startCount < Per_Page){
              startCount++;
            return( 
            <tr>              
              <td>{obj.title}</td>
              {(permission === true) ? <td>                              
              <i class='fas fa-pen' onClick={()=>this.editMe(index)}/>
               {/* {this.state['edit'+index] ? 
                <EditModalWindow edit={true} closeModal={()=>this.editMeClose(index)} action={this.props.action} loginAction={this.props.loginAction}
                 webFormNames={this.props.webFormNames}
                  form={obj}/>             
                : null}        */}
            </td> : null}
            <td><i class='fas fa-eye' onClick={()=>this.openModalView(index)}/>
						{this.state['modalIsRead'+index] ?
						<ViewWebForm closeModal={()=>this.closeModalView(index)}  data={obj}/> : null}
						</td>
            </tr>)
          }
          }) :
          <tr><td colSpan={(permission === true) ? "3" : "2"}>No Record Found</td></tr>
          }
        </tbody>
        </Table> 
        {!_.isEmpty(items) ?
        <Pagination>
      <Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
      <Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
        {items[activePage-1]}
        {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
        {items[activePage+1]}
      <Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
      <Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
      </Pagination> : null}
      </div>}
      </div>)
  }


}